import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import WhiteLogo from '../../../images/logos/logo-white.svg';
import DarkLogo from '../../../images/logos/logo.svg';

const Logo = (props) => {
  const { mode } = props;
  return (
    <StyledLink to="/">
      {mode === 'light' ? <DarkLogo /> : <WhiteLogo />}
    </StyledLink>
  );
};

const StyledLink = styled(Link)`
  display: flex;
`;

export default Logo;
